import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import { monthArray } from "../../constants";

const TimeFormat = (time) => {
  let T = time.split(":");
  var hours = T[0];
  var minutes = T[1] < 10 ? `0${T[1]}` : T[1];
  var format = "AM";
  var h = hours;
  if (h >= 12) {
    h = hours - 12;
    format = "PM";
  }
  if (h == 0) {
    h = 12;
  }
  return h + ":" + minutes + " " + format;
};

const DateFormat = (date) => {
  // return new Date(date).toLocaleDateString('en-US', {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const localDateTime = (date, time) => {
  const UTCDate = zonedTimeToUtc(date + " " + time, "GMT");
  // const convertedDate = utcToZonedTime(UTCDate.toISOString(), timeZOne);
  // const localDate = `${UTCDate.getFullYear()}-${
  //   UTCDate.getMonth() + 1
  // }-${UTCDate.getDate()}`;

  const localDate = new Date(
    UTCDate.getFullYear(),
    UTCDate.getMonth(),
    UTCDate.getDate()
  );

  const localTime = `${UTCDate.getHours()}:${UTCDate.getMinutes()}`;
  return { localDate, localTime };
};

export const newDateFormat = (date, time) => {
  // const UTCDate = zonedTimeToUtc(date + ' ' + time, 'GMT');
  // // const convertedDate = utcToZonedTime(UTCDate.toISOString(), timeZOne);
  // // const localDate = `${UTCDate.getFullYear()}-${
  // //   UTCDate.getMonth() + 1
  // // }-${UTCDate.getDate()}`;

  // const localDate = new Date(
  //   UTCDate.getFullYear(),
  //   UTCDate.getMonth(),
  //   UTCDate.getDate()
  // );

  // const localTime = `${UTCDate.getHours()}:${UTCDate.getMinutes()}`;

  const { localDate, localTime } = localDateTime(date, time);

  // (localDate, 'next time', localTime);
  const eventDateR = DateFormat(localDate);
  const eventTimeR = TimeFormat(localTime);
  // (eventDate, 'final date and time', eventTime);

  return { eventDateR, eventTimeR };
};

export const dateMonth = (eventDate) => {
  const eventDateArr =  eventDate?.split("-");
  console.log(eventDateArr)
  return (
    {
      date: eventDateArr[2],
     month: monthArray[eventDateArr[1]], 

    }
  )
};
